import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import PublicEnv from 'shared/utils/public-env';

type RumActionContext = Record<string, boolean | number | string>;

/**
 * Records a low-cardinality custom RUM action when the admin RUM SDK is active.
 * Admin RUM is intentionally production-only, so non-production calls remain inert.
 */
export function trackRumAction(name: string, context: RumActionContext): void {
  if (PublicEnv.appEnv !== 'production') return;

  try {
    datadogRum.addAction(name, context);
  } catch {
    // Browser telemetry must never alter authentication or navigation behavior.
  }
}

export function initializeRum(currentVersion: string): void {
  const sharedConfig = {
    applicationId: '9d60d694-ced3-417c-995b-dd454c454e4a',
    clientToken: 'pub6f5efdaab22141c2cd59685f6a22f6cb',
    env: PublicEnv.appEnv,
    service: 'ecomm-admin-react',
    sessionSampleRate: 100,
    site: 'datadoghq.com',
    version: currentVersion,
    allowedTracingOrigins: [/https:\/\/.*\.dutchie\.com/],
  };

  if (PublicEnv.appEnv === 'production') {
    datadogRum.init({
      ...sharedConfig,
      sessionReplaySampleRate: 0,
      trackFrustrations: true,
      trackLongTasks: true,
      trackResources: true,
      trackUserInteractions: true,
    });

    datadogRum.startSessionReplayRecording();

    datadogLogs.init({
      ...sharedConfig,
      forwardErrorsToLogs: false,
    });
  }
}
